import React from 'react'

import { useTheme } from 'styled-components'

import { FormLabel } from './FormLabel'

interface IProps {
  items: {
    label: string
    value: string | number
  }[]
  label?: string
  errorMessage?: string
  isRequired?: boolean
  mb?: number
  defaultValue?: string
  placeholder?: string
  onValueChange?: (value: string) => void
  [key: string]: unknown
}

export function FormSelect({
  items,
  label,
  errorMessage,
  isRequired,
  mb,
  defaultValue,
  placeholder,
  onValueChange,
  ...rest
}: IProps) {
  const { colors } = useTheme()

  const invalid = !!errorMessage

  const borderColor = invalid ? colors.textError : colors.formBorder

  return (
    <div style={{ marginBottom: mb }}>
      <FormLabel isInvalid={invalid} isRequired={isRequired}>
        {label}
      </FormLabel>
      <select
        defaultValue={defaultValue ?? (placeholder ? '' : undefined)}
        onChange={(e) => onValueChange?.(e.target.value)}
        style={{
          fontSize: '16px',
          height: 48,
          color: colors.text,
          borderColor,
          backgroundColor: colors.background,
          borderRadius: 8,
          width: '100%',
          padding: '4px 10px',
          borderWidth: 1,
          borderStyle: 'solid',
        }}
      >
        {placeholder && !defaultValue && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {items.map(({ label, value }) => (
          <option key={value} value={String(value)}>
            {label}
          </option>
        ))}
      </select>

      {invalid && <span style={{ color: colors.textError, fontSize: 12 }}>{errorMessage}</span>}
    </div>
  )
}
